/**
 * Slide-over overlay controller (mirrors the React ContactPages).
 *
 * [data-overlay="inquiries|private-events"] triggers (nav sublinks, contact
 * buttons, reservation modal links) open the matching sheet over the current
 * page — no navigation (the href is a no-JS fallback to the standalone page).
 * The "switch" links inside a form slide one sheet out while the other slides
 * in. Close/Esc slides the sheet down. Opening also dismisses the nav menu and
 * reservation modal so only one layer is active.
 */
(function () {
  var CLOSE_MS = 1200;

  var host = document.querySelector('[data-overlay-host]');
  if (!host) return;

  var sheets = {
    inquiries: host.querySelector('[data-overlay-sheet="inquiries"]'),
    'private-events': host.querySelector('[data-overlay-sheet="private-events"]')
  };

  var layers = window.BaldiLayers;
  var current = null;
  var unlockTimer;

  function setVisible(sheet, on) {
    if (!sheet) return;
    sheet.classList.toggle('is-visible', on);
    sheet.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  function dismissOtherLayers() {
    if (layers) {
      layers.close('nav');
      layers.close('reservation');
    }
  }

  function open(type) {
    if (!sheets[type]) return;
    window.clearTimeout(unlockTimer);
    dismissOtherLayers();
    if (current && current !== type) setVisible(sheets[current], false);
    setVisible(sheets[type], true);
    current = type;
    if (layers) layers.lock('overlay');
  }

  function close() {
    if (!current) return;
    setVisible(sheets[current], false);
    current = null;
    unlockTimer = window.setTimeout(function () {
      if (layers) layers.unlock('overlay');
    }, CLOSE_MS);
  }

  function bindAll(selector, root, handler) {
    var els = (root || document).querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      els[i].addEventListener('click', handler);
    }
  }

  bindAll('[data-overlay]', document, function (event) {
    event.preventDefault();
    open(this.getAttribute('data-overlay'));
  });

  bindAll('[data-overlay-switch]', host, function (event) {
    event.preventDefault();
    open(this.getAttribute('data-overlay-switch'));
  });

  bindAll('[data-overlay-close]', host, function (event) {
    event.preventDefault();
    close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && current) close();
  });

  document.addEventListener('baldi:overlay:close', close);

  // ----- Show the confirmation after a native form submit + reload -----
  // The contact forms post natively via {% form 'contact' %} (a full reload —
  // the only path Shopify's live endpoint reliably accepts). On success Shopify
  // returns to …?contact_posted=true#<form-id>, so we reveal that form's success
  // letter and, when it lives in a sheet, reopen the sheet to show it.
  function sheetTypeOf(node) {
    for (var type in sheets) {
      if (sheets[type] && sheets[type].contains(node)) return type;
    }
    return null;
  }

  function revealSuccess(form) {
    var hide = form.querySelectorAll(
      '[data-form-body], [data-form-actions], [data-form-hide]'
    );
    for (var i = 0; i < hide.length; i++) hide[i].style.display = 'none';
    var ok = form.querySelector('[data-form-success]');
    if (ok) ok.hidden = false;
  }

  if (/[?&]contact_posted=true/.test(window.location.search)) {
    var postedForm = window.location.hash
      ? document.getElementById(window.location.hash.slice(1))
      : null;
    if (postedForm) {
      revealSuccess(postedForm);
      var postedType = sheetTypeOf(postedForm);
      if (postedType) open(postedType);
    }
    // Strip ?contact_posted (and the form anchor) from the URL so a refresh
    // loads clean and shows the normal form instead of re-showing the letter.
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }
})();
